import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  justify-content: space-between;
  position: relative;
  width: 100%;

  & .react-tagsinput .react-tagsinput-remove {
    margin-top: 7px;
  }
  & .react-tagsinput-input {
    width: 100%;
  }
`;
